// ---------------------------------------------------------
// GET products/<product-handle>.js returns the product in JSON.
// ---------------------------------------------------------
Shopify.getProduct = function(handle, callback) {
  jQuery.getJSON('/products/' + handle + '.js', function (product, textStatus) {
    if (typeof callback === 'function') {
      callback(product);
    } else {
      Shopify.onProduct(product);
    }
  });
};

////////////////// Custom JS for setup product form on blog page //////////////////

$("#product-handle").each((ix, em) => {
  // Get a product handle
  let currentProductHandle = $(em).text().toString().trim();
  if (currentProductHandle) {
    $.get(`/products/${currentProductHandle}?view=en-product-view-article`, (data) => { // Get request of product based on its handle
      $(em).html(data);
      $(em).fadeIn(0);

      // Quantity selector code
      $(em).find('.shopify-product-form .en-btn-number').on('click', function (e) {
        e.preventDefault();

        var fieldName = $(this).attr('data-field');
        var type = $(this).attr('data-type');
        var input = $(this).siblings('input[name="quantity"]');
        var currentVal = parseInt(input.val());

        if (!isNaN(currentVal)) {
          if (type === 'minus') {
            if (currentVal > 1) {
              input.val(currentVal - 1).change();
            }
          } else if (type === 'plus') {
            input.val(currentVal + 1).change();
          }
        } else {
          input.val(1);
        }
      });

      // Change the image on variant change
      $(em).find('.swatch input').on('change', function () {
        var this_ = $(this);
        let selectElementOptions = $(this).closest("form").find("select.product-form__variants option");
        let priceElement = $(this).closest("form").find(".product-item-caption-price-current");
        var selectedValue = $(em).find('.swatch input:checked').val().trim();
        var selectedOption;

        selectElementOptions.each(function () {
          var swatchValue = $(this).text().trim();
          if (swatchValue === selectedValue) {
            $(this).prop('selected', true);
            selectedOption = $(this);
          } else {
            $(this).prop('selected', false);
          }
        });

        if (selectedOption) {
          var variantPrice = selectedOption.data('variant-price');
          var imageUrl = selectedOption.data('image-src');
          if (variantPrice !== undefined) {
            priceElement.text(Shopify.formatMoney(variantPrice, theme.moneyFormat));
          } else {
            console.error("variantPrice is undefined. Check if data-variant-price attribute is set correctly.");
          }
          if (imageUrl !== undefined) {
            $(em).find('img.main_image').attr('src', imageUrl);
          } else {
            console.error("imageUrl is undefined. Check if data-image-src attribute is set correctly.");
          }
        } else {
          console.error("selectedOption is undefined. No matching option found.");
        }
      });
    }).fail((jqXHR, textStatus, errorThrown) => {
      console.error("Error loading product: ", textStatus, errorThrown);
    });
  }
});
